/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as Map} from "../assets/img/icons/map.svg";
import {useTranslation} from "react-i18next";

const PartBox = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <div className='partBox'>
            <div className='partBox__row'>
                { props.part.listing_image && <Link to={props.link} className='partBox__img'>
                    <img src={props.part.listing_image} alt={props.part.title}/>
                </Link>}
                <div className='partBox__content'>
                    <Link to={props.link} className='partBox__title'>{props.part.part_title} {props.part.specs && <>({props.part.specs})</>} </Link>
                    <div className='partBox__info'>{props.part.make_title} {props.part.model_name}, {props.part.model_year}, {props.part.cc_title}, {props.part.fuel_title} </div>

                    { Array.isArray(props.part.part_numbers) && <div className='partNumbers'>
                        { props.part.part_numbers.length > 0 && <>
                            <div className='partNumbers__label'>{ t('parts.partnumber' ) }</div>
                            <div className='partNumbers__row'>
                            { props.part.part_numbers.map( (number, index)=>(
                                <div className='partNumbers__item' key={index}>{number.part_number}</div>
                            ) ) }
                            </div>
                        </>}
                    </div>}

                    <div className='partBox__footer'>
                        <Link to={`/${i18n.language}/mini-site/cars/${props.part.merchant_id}/${encodeURIComponent(props.part.merchant_slug)}`} className='mb-1 medium-text'>{props.part.merchant_company_name}</Link>
                        <div className='icon-link'>
                            <div className='icon-link__icon'><Map/></div>
                            <div className='icon-link__label small-text'>{props.part.city_title}, {props.part.address}, {props.part.postalcode}</div>
                        </div>
                    </div>
                </div>
                <div className='partBox__prices'>
                    <div className='partBoxPrice'>
                        <div className='partBoxPrice__label'>{t('parts.price' )}:</div>
                        <div className='partBoxPrice__price-box'>
                            <div className='partBoxPrice__price'>{props.part.price} €</div>
                            <div className='partBoxPrice__vat'>{props.part.price_with_vat} € ( { t('parts.incVat' ) } )</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartBox;
